import React from "react";
import ControlledSlider from "./Slider/Slider";
import "./App.css";

const data_source = document.getElementById('dl-calc');
const vynos_yearly = [];

// Constands for these for simplicity, would typically be props
const max = parseInt(data_source.dataset.max);
const min = parseInt(data_source.dataset.min);
const step = parseInt(data_source.dataset.step);
const value = parseInt(data_source.dataset.startvalue);
const dlrate = data_source.dataset.rate;
const dlmonths = data_source.dataset.months;
const formUrl = data_source.dataset.formUrl || '#objednavka-form';
const formInputId = (data_source.dataset.formInputId || 'ff_4_investovana_castka').replace(/^#/, '');

const calculate_vynos = (val= value, months = dlmonths, rate = dlrate) => {
    if(months.includes(",") && rate.includes(",")) {
        let months_arr = months.split(",");
        let rate_arr = rate.split(",");
        let vynos = 0;
        let vynos_temp_yearly = 0;
        months_arr.forEach( (item_months, index) =>
            {
                vynos_temp_yearly = val * (rate_arr[index] / 100) / 12 * item_months;
                vynos = vynos + vynos_temp_yearly;

                vynos_yearly[index] = new Intl.NumberFormat('cs-CS', { style: 'currency', currency: 'CZK', maximumFractionDigits: 0 }).format(vynos_temp_yearly);
            }
        );
        return vynos;
    } else {
        return  val * (rate / 100) / 12 * months;
    }
}




const vynos = new Intl.NumberFormat('cs-CS', { style: 'currency', currency: 'CZK', maximumFractionDigits: 0 }).format(calculate_vynos());
const vyplaceno = new Intl.NumberFormat('cs-CS', { style: 'currency', currency: 'CZK', maximumFractionDigits: 0 }).format(calculate_vynos() + value * 1);


class App extends React.Component {
    state = {
        // Set state values to reflect consts/props
        sum: new Intl.NumberFormat('cs-CS', { style: 'currency', currency: 'CZK', maximumFractionDigits: 0 }).format(value),
        sliderSum: value,
        step: step,
        vynos: vynos,
        vyplaceno: vyplaceno,
        investDLCount: value/step
    };


    onInputChange = value => {
        if (value) {
            const sum = parseInt(value, 0) * step;
            const sumTemp = new Intl.NumberFormat('cs-CS', { style: 'currency', currency: 'CZK', maximumFractionDigits: 0 }).format(sum);
            this.setState({
                sum: sumTemp
            });

            // Update slider with new value only if it’s within the sliders domain
            if (sum >= min && sum <= max) {
                this.setState({ sliderSum: sum });
            }
            this.setState({ investDLCount: value });
        } else {
            // Empty string is preferred when dealing with controlled components
            // this.setState({ sum: "" });
        }
        this.onChangeDLValues(value * step);
    };



    onSlideStart = value => {
        // Set the step value sent to the slider when the user starts dragging
        this.setState({ step: step });
        this.onChangeDLValues(value);
    };

    onSliderChange = value => {
        const sum = parseInt(value, 10);
        const sumTemp = new Intl.NumberFormat('cs-CS', { style: 'currency', currency: 'CZK', maximumFractionDigits: 0 }).format(sum);
        // When the slider is changed, set both input and slider values to reflect new value
        this.setState({
            sum: sumTemp,
            sliderSum: sum,
            investDLCount: sum / step
        });

        this.onChangeDLValues(value);
    };

    onChangeDLValues = (investValue) => {
        let vynosTemp = calculate_vynos(investValue);
        let vyplacenoTemp = vynosTemp + investValue * 1;
        vynosTemp = new Intl.NumberFormat('cs-CS', { style: 'currency', currency: 'CZK', maximumFractionDigits: 0 }).format(vynosTemp)
        vyplacenoTemp = new Intl.NumberFormat('cs-CS', { style: 'currency', currency: 'CZK', maximumFractionDigits: 0 }).format(vyplacenoTemp)

        this.setState({vynos: vynosTemp, vyplaceno: vyplacenoTemp });
    }

    decrementDLValues = () => {
        if(this.state.investDLCount > 1) {
            this.onInputChange(this.state.investDLCount - 1);
        }
    }
    incrementDLValues = () => {
        this.onInputChange(this.state.investDLCount + 1);
    }

    handleOrderClick = () => {
        const investmentInput = document.getElementById(formInputId);

        if (investmentInput) {
            investmentInput.value = this.state.sliderSum;
            investmentInput.dispatchEvent(new Event('input', { bubbles: true }));
            investmentInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    render() {
        return (
                <div className="App">
                    <section className="dlinvestcalc">

                        <h3 >Kolik chcete investovat?</h3>
                        <div className="invest-value">{this.state.sum}</div>
                        <ControlledSlider
                            min={min}
                            max={max}
                            step={this.state.step}
                            defaultValue={this.state.sliderSum}
                            onUpdate={value => this.onSliderChange(value)}
                            onSlideStart={value => this.onSlideStart(value)}
                        />

                        <div className="dl-count-cov">
                            <label htmlFor="dl-count">Počet dluhopisů:</label><br />

                            <div className="dl-numer-cov">
                                <span className="dl-count-decrement" onClick={e => this.decrementDLValues()} >&ndash;</span>
                                <input id="dl-count" name="bondCount" type="number" min="1" max="100" value={this.state.investDLCount}
                                       onChange={e => this.onInputChange(e.target.value)}
                                       readOnly
                                />
                                <span className="dl-count-incremet" onClick={e => this.incrementDLValues()} >&#43;</span>
                            </div>
                        </div>

                        {vynos_yearly &&
                            vynos_yearly.map((vynos_year, index) => {
                                return (
                                    <div key={index} className="vynosyearly">
                                        <div className="vynosyearly__title">Výnos za {index+1}. výnosové období: </div>
                                        <div className="vynosyearly__suma">{vynos_year}</div>
                                    </div>
                                );
                            })
                        }
                        <div className="cisty-vynos-cov">
                            <div className="vynos-title">Celkový výnos za celé období:</div>
                            <div className="vynos-suma">{this.state.vynos}</div>
                            <div className="vyplaceno-title">Celkově bude vyplaceno:</div>
                            <div className="vynos-suma">{this.state.vyplaceno}</div>
                        </div>
                        <nav>
                            <a href={formUrl} onClick={this.handleOrderClick}>
                                <button className="dlinvestcalc-orderBtn" type="button">Nezávazně objednat</button>
                            </a>
                        </nav>
                        <div className="sample__attention">Výpočty jsou pouze orientační</div>
                    </section>
                </div>
        );
    }
}

export default App;
